/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_3_AnswerInputs */

const en_svc_integration_faq_3_answer = /** @type {(inputs: Svc_Integration_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accuracy depends on how consistent the documents are. We measure it on your real documents before launch, and design the system so fields it is unsure about go to a person instead of straight into your records.`)
};

const lv_svc_integration_faq_3_answer = /** @type {(inputs: Svc_Integration_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precizitāte ir atkarīga no tā, cik vienveidīgi ir dokumenti. Pirms ieviešanas to izmērām ar Jūsu reālajiem dokumentiem un veidojam sistēmu tā, lai lauki, par kuriem tā nav pārliecināta, nonāktu pie cilvēka, nevis tieši Jūsu ierakstos.`)
};

/**
* | output |
* | --- |
* | "Accuracy depends on how consistent the documents are. We measure it on your real documents before launch, and design the system so fields it is unsure about ..." |
*
* @param {Svc_Integration_Faq_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_3_answer = /** @type {((inputs?: Svc_Integration_Faq_3_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_3_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_3_answer(inputs)
	return en_svc_integration_faq_3_answer(inputs)
});